import type { IconAsset } from '../Icon.types';

export const minus: IconAsset = {
  bold: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M4 10h16v3H4z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M3 8.5H17V11.5H3V8.5Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M2 6.5H14V9.5H2V6.5Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
  regular: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M4 11h16v2H4z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M3 9h14v2H3z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M2 7h12v2H2z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
};
